var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lvl"},[_vm._v("L V L  "+_vm._s(_vm.level))])
}
var staticRenderFns = []

export { render, staticRenderFns }